

const HRTitleHeader = ({title, info}: {title: string, info: string}) => {
  return (
    <div className="flex items-start justify-between mb-6">
      <h2 className="text-xl font-semibold text-[#0a2540]">
        {title}
      </h2>
      <span className="text-sm text-gray-500">
        {info}
      </span>
    </div>
  );
}

export default HRTitleHeader